module.exports = __webpack_public_path__ + "media/large/real_estate_condos_rent-336323dc.jpeg";